import * as React from "react";
import { IconProps } from "../types";

const KnowledgeCheckIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g transform="translate(1.75 2.322) scale(1.075055)">
          <path
            d="M8.67222 11.7546L12.8699 5.54249C12.957 5.41338 12.8644 5.23916 12.7089 5.23916H8.99189L9.64989 0.800381C9.67867 0.604381 9.422 0.504048 9.31078 0.668937L5.11311 6.88105C5.026 7.01016 5.11856 7.18438 5.27411 7.18438H8.99111L8.33311 11.6232C8.30433 11.8192 8.561 11.9195 8.67222 11.7546Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M0.583333 6.21138H3.11111"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M2.52778 3.6836H4.08333"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M2.52778 8.73916H4.08333"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      </svg>
    );
  },
);

export default KnowledgeCheckIcon;
